interface SectionLabelProps {
  label: string;
}

function SectionLabel({ label }: SectionLabelProps) {
  return (
    <h2 className="section-label">
      <span className="line" />
      {label}
      <span className="line grow" />
    </h2>
  );
}

export default SectionLabel;
